/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { RouteComponentProps } from "react-router-dom";
import AppRouterSwitch from "../../../../AppRouterSwitch";
import TabContainer from "../../../../Basis/Components/TabContainer";
import View from "../../../../Basis/Components/View";
import ViewHeader from "../../../../Basis/Components/ViewHeader";
import { ClipboardListIcon, MoneyIcon } from "../../../../Basis/FontAwesome";
import useQuery from "../../../../Basis/Utils/useQuery";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";
import Belegart from "../../Queries/Belegart";
import LadeGutschriftZuMandant from "../../Queries/LadeGutschriftZuMandant";
import LadeRechnungZuMandant from "../../Queries/LadeRechnungZuMandant";

export type MandantBelegViewProps = RouteComponentProps<{
    belegId: string,
    belegart: Belegart,
}>;

export default function MandantBelegView(props: MandantBelegViewProps) {
    const { t } = useTranslation();
    const { map } = props.match.params.belegart === "RECHNUNG"
        ? useQuery({
            query: LadeRechnungZuMandant,
            input: { rechnungId: props.match.params.belegId },
        })
        : useQuery({
            query: LadeGutschriftZuMandant,
            input: { gutschriftId: props.match.params.belegId },
        });

    const tabs = [
        {
            caption: t(translationKeys.mandantBelegView.details),
            to: props.match.url,
            icon: <ClipboardListIcon />,
        },
        {
            caption: t(translationKeys.mandantBelegView.provisionen),
            to: `${props.match.url}/provisionen`,
            icon: <MoneyIcon />,
            visible: props.match.params.belegart === "RECHNUNG",
        }
    ];

    return (
        <View>
            {map(beleg => (
                <>
                    <ViewHeader
                        title={beleg.nummer}
                        processCaption={t(translationKeys.mandantBelegView.beleg)}
                        viewMenuItems={tabs}
                    />
                    <TabContainer
                        history={props.history}
                        location={props.location}
                        match={props.match}
                        items={tabs}
                    >
                        <AppRouterSwitch
                            parentPath={props.match.path}
                            additionalProps={props.match.params.belegart === "RECHNUNG"
                                ? { abrechnungsdatum: beleg.datum, rechnungId: beleg.id }
                                : { abrechnungsdatum: beleg.datum, gutschriftId: beleg.id }
                            } />
                    </TabContainer>
                </>
            ))}
        </View>
    );
}